export default "__VITE_ASSET__4b1e0c50__"